import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import './index.scss'
import { Steps } from 'antd'
import QRCode from 'qrcode'
import InspectItemCom from './module/InspectItem'
import ExterInterInsp from './module/exter-inter-inspect'
import BasicInfor from './module/basic-infor'
import { detailReport } from './service'

const { Step } = Steps

const ReportDetail = ({
  newTestReport,
  testObject,
  defectImages,
  base,
  testReport,
  carCity,
  cid,
  isReInspection
}) => {
  const isReportData = !!newTestReport // 是否返回检测报告数据
  // 未返回检测报告，返回首页
  useEffect(() => {
    if (!isReportData) {
      window.location.href = 'https://www.renrenche.com/'
    }
  }, [])
  const isV6 = Number(base?.inspectVersion) === 6 || Number(base?.inspectVersion) > 600
  const [erweima, setErweima] = useState()
  useEffect(() => {
    if (!isV6) {
      QRCode.toDataURL(`https://m.renrenche.com/cn/inspect/${cid}`)
        .then((url) => {
          setErweima(url)
        })
        .catch((err) => {
          setErweima(null)
          console.error(err)
        })
    }
  }, [])
  return (
    <>
      <div className="r-inspect-report-detail">
        {/* v6及v6以上的车 */}
        {isV6 && newTestReport && newTestReport.report && (
          <>
            <BasicInfor
              base={base}
              carCity={carCity}
              testReport={testReport}
              isReInspection={isReInspection}
              {...{ testObject }}
              {...{ newTestReport }}
            />
            <InspectItemCom
              key="重大事故排查"
              report={newTestReport}
              part="重大事故排查"
              showIndex={['重大撞击排查', '水泡车排查', '火烧车排查']}
              showIcon
              col={3}
            />
            <InspectItemCom
              key="轻微碰撞排查"
              report={newTestReport}
              part="轻微碰撞排查"
              showIndex={['轻微碰撞排查']}
            />
            <InspectItemCom
              key="易损易耗部件"
              report={newTestReport}
              part="易损易耗部件"
              showIndex={['易损易耗部件']}
            />
            {/* 外观内饰检测  */}
            <ExterInterInsp
              {...{ newTestReport }}
              {...{ defectImages }}
              {...{ base }}
            />
            <InspectItemCom
              key="功能部件检测"
              report={newTestReport}
              part="功能部件检测"
              showColumns={[
                ['安全系统', '灯光、空调系统', '悬挂系统', '随车工具'],
                ['转向系统', '动力、传动系统', '内部配置']
              ]}
              showIcon
            />
            <InspectItemCom
              key="启动检测"
              report={newTestReport}
              part="启动检测"
              showIndex={['启动检测']}
            />
            {newTestReport.report['新能源专项检测'] && (
              <InspectItemCom
                key="新能源专项检测"
                report={newTestReport}
                part="新能源专项检测"
                showIndex={['新能源专项检测']}
              />
            )}
          </>
        )}
        {/* v6以下的车 */}
        {!isV6 && (
          <>
            <div className="r-inspect-report-detail__lessV6 clearfix">
              <div className="r-inspect-report-detail__lessV6-infol">
                <h1 className="r-inspect-report-detail__lessV6-infol-title">
                  人人车检测报告
                </h1>
                <p className="r-inspect-report-detail__lessV6-infol-desc">
                  人人车249项标准检测技术，为中国汽车流通协会认证技术，由资深行业权威专家制定，前后两次专业检测，层层为您把关排除隐患，精选放心车源，拒绝重大事故车、水泡车、火烧车。
                </p>
              </div>
              <div className="r-inspect-report-detail__lessV6-infor clearfix">
                <div className="r-inspect-report-detail__lessV6-infor-erweima">
                  {erweima && <img src={erweima} alt="人人车检测报告" />}
                </div>
                <div className="r-inspect-report-detail__lessV6-infor-step">
                  <h2 className="r-inspect-report-detail__lessV6-infor-step-title">
                    微信扫码查看完整检测报告{' '}
                  </h2>
                  <Steps direction="vertical" className="lessV6-step">
                    <Step title="打开微信" status="process" />
                    <Step
                      title="点击页面右上角“+”号，打开扫一扫"
                      status="process"
                    />
                  </Steps>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  )
}

ReportDetail.getInitialProps = async ({ ctx }) => {
  try {
    const result = await detailReport({ cid: ctx.query.id })
    return { ...result.data, cid: ctx.query.id }
  } catch (err) {
    console.log('ReportDetail.getInitialProps---err---', err)
    // 未返回检测报告，返回首页
    ctx.res.writeHead(301, { Location: 'https://www.renrenche.com' }).end()
    return {}
  }
}

export default ReportDetail

ReportDetail.propTypes = {
  newTestReport: PropTypes.object,
  testObject: PropTypes.any,
  defectImages: PropTypes.array,
  base: PropTypes.object,
  testReport: PropTypes.object,
  carCity: PropTypes.string,
  cid: PropTypes.string,
  isReInspection: PropTypes.number
}

ReportDetail.defaultProps = {
  newTestReport: {},
  testObject: null,
  defectImages: [],
  base: {},
  testReport: {},
  carCity: '',
  cid: '',
  isReInspection: 0
}
